import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';

const PrimaryGreenButton = styled(Button)({
    fontFamily: 'inherit',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '24px',
    height: '48px',
    borderRadius: '28px',
    backgroundColor: '#00693E',
    color: 'white',
    minWidth: '100px',
    gap: '10px',
    justifyContent: 'center',
    boxShadow: 'none',
    textTransform: 'unset',
    '&:hover': {
        backgroundColor: '#00693E',
        borderColor: '#00693E',
        boxShadow: 'none',
    },
    '&:active': {
        boxShadow: 'none',
        backgroundColor: '#00693E',
        borderColor: '#00693E',
    },
})
export default PrimaryGreenButton
